// extracted by mini-css-extract-plugin
export var circle = "_42-2";
export var icon = "_42-a";
export var iconHighlight = "_42-0";
export var lg = "_42-8";
export var md = "_42-7";
export var outline = "_42-4";
export var sm = "_42-6";
export var square = "_42-1";
export var xl = "_42-9";
export var xs = "_42-5";
export var xxs = "_42-3";